import React, { useState, useRef, useEffect } from 'react';
import { Smile } from 'lucide-react';

const CATEGORIES = [
  {
    name: 'Envío',
    items: ['🚚', '📦', '✈️', '🏍️', '🛵', '🚀', '⏱️', '⏰', '📍', '🗺️'],
  },
  {
    name: 'Calidad',
    items: ['✓', '✅', '⭐', '🌟', '💎', '👑', '🥇', '🏆', '🔥', '💯'],
  },
  {
    name: 'Ofertas',
    items: ['🎉', '🎁', '💥', '⚡', '🏷️', '💰', '💸', '🔖', '📢', '🎊'],
  },
  {
    name: 'Vape',
    items: ['💨', '☁️', '💧', '🌫️', '🍭', '🍬', '🍓', '🍋', '🥭', '🍇'],
  },
  {
    name: 'Ecom',
    items: ['🛒', '🛍️', '💳', '🏪', '📱', '📞', '💬', '👍', '❤️', '🔞'],
  },
];

const EmojiPicker = ({ onPick, buttonClassName = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        title="Insertar icono"
        data-testid="emoji-picker-btn"
        className={buttonClassName || 'w-9 h-9 rounded-md bg-white/5 hover:bg-white/10 text-orange-300 inline-flex items-center justify-center'}
      >
        <Smile className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 z-50 w-72 rounded-2xl border border-white/15 bg-neutral-950 shadow-2xl p-3">
          {CATEGORIES.map((cat) => (
            <div key={cat.name} className="mb-2 last:mb-0">
              <p className="text-[10px] uppercase tracking-widest font-bold text-white/40 mb-1.5">{cat.name}</p>
              <div className="grid grid-cols-10 gap-1">
                {cat.items.map((e) => (
                  <button
                    type="button"
                    key={e}
                    onClick={() => { onPick(e); setOpen(false); }}
                    className="aspect-square flex items-center justify-center rounded-md hover:bg-orange-500/20 text-base transition-colors"
                  >
                    {e}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
